(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ks-recently-viewed"]) return;
  try {
    
  function initRecentProducts(section){
    if(!section||section.dataset.initialized)return;
    section.dataset.initialized='true';
    var current=section.dataset.currentHandle;
    var grid=section.querySelector('[data-recent-grid]');
    var root=section.dataset.root||'/';
    var key='kp_recently_viewed_v2';
    var strings=JSON.parse(section.querySelector('[data-recent-strings]').textContent);
    var records=[];
    try{var saved=JSON.parse(localStorage.getItem(key)||'[]');if(Array.isArray(saved))records=saved.filter(function(record){return record&&/^[a-z0-9-]+$/.test(record.handle)&&/^\d+$/.test(String(record.variant))})}catch(error){}
    records=records.filter(function(record,index,array){return record.handle!==current&&array.findIndex(function(item){return item.handle===record.handle&&String(item.variant)===String(record.variant)})===index});
    function recordVisit(variant){
      if(!/^\d+$/.test(String(variant)))return;
      var next=[{handle:current,variant:String(variant)}].concat(records).slice(0,12);
      try{localStorage.setItem(key,JSON.stringify(next))}catch(error){}
    }
    recordVisit(section.dataset.currentVariant);
    window.addEventListener('kp:variant-change',function(event){if(event.detail&&event.detail.handle===current)recordVisit(event.detail.id)});
    if(!records.length)return;
    var currency;
    try{currency=new Intl.NumberFormat(document.documentElement.lang||'es-MX',{style:'currency',currency:section.dataset.currency})}catch(error){return}
    function make(tag,className,value){var el=document.createElement(tag);if(className)el.className=className;if(value!==undefined)el.textContent=value;return el}
    function isTorinoFixed(item,variant){
      return item.handle==='blusa-dama-v'&&[46051855040661,46051855630485,46051855728789].includes(Number(variant.id))&&variant.price===9900&&Date.now()>=Date.parse('2026-10-02T08:00:00Z')&&Date.now()<=Date.parse('2026-11-18T06:59:59Z');
    }
    function card(item,record){
      if(!item||!item.handle||!item.title||!Array.isArray(item.variants))return null;
      var variant=item.variants.find(function(value){return String(value.id)===String(record.variant)});
      if(!variant||typeof variant.price!=='number')return null;
      var quote=variant.price===0||(Array.isArray(item.tags)&&item.tags.indexOf('sportshop')!==-1);
      var colorIndex=Array.isArray(item.options)?item.options.findIndex(function(option){return /colou?r/i.test(typeof option==='string'?option:option.name||'')}):-1;
      function colorOf(value){return Array.isArray(value.options)?value.options[colorIndex]:value['option'+(colorIndex+1)]}
      function imageOf(value){return value&&value.featured_image&&(value.featured_image.src||value.featured_image.url)}
      function safeImage(value){try{var url=new URL(value,location.origin);if(url.protocol!=='https:'&&url.protocol!=='http:')return '';url.searchParams.set('width','600');return url.href}catch(error){return ''}}
      var image=imageOf(variant);
      if(!image&&colorIndex>=0){
        var matching=item.variants.find(function(value){return colorOf(value)===colorOf(variant)&&imageOf(value)});
        if(matching)image=imageOf(matching);
        else if(new Set(item.variants.map(colorOf)).size>1)return null;
      }
      image=safeImage(image||item.featured_image);
      if(!image)return null;
      var productURL=new URL(root+'products/'+encodeURIComponent(item.handle),location.origin);
      productURL.searchParams.set('variant',String(variant.id));
      var currentURL=new URL(location.href);
      ['preview_theme_id','preview_key'].forEach(function(name){if(currentURL.searchParams.has(name))productURL.searchParams.set(name,currentURL.searchParams.get(name))});
      var headwear=(Array.isArray(item.tags)&&item.tags.indexOf('capshop')!==-1)||/gorra|hat/i.test(item.type||'');
      var article=make('article','card card--editorial'+(headwear?' card--headwear':'')+' ks-recent__card');article.setAttribute('data-card','');
      article.dataset.cardQuote=String(quote);article.dataset.quoteLabel=strings.quote;article.dataset.discountLabel=strings.discount;
      var media=make('a','media media--editorial');media.href=productURL.href;media.setAttribute('data-card-media','');
      media.setAttribute('aria-label',strings.return_to.replace('__PRODUCT__',item.title));
      var img=make('img','card__image');img.src=image;img.alt=item.title;img.loading='lazy';img.width=600;img.height=750;media.appendChild(img);
      var discount=!quote&&variant.compare_at_price>variant.price?Math.round((1-variant.price/variant.compare_at_price)*100):0;
      var fixedOffer=isTorinoFixed(item,variant);
      var badge=section.querySelector('[data-recent-badge]').content.firstElementChild.cloneNode(true);
      badge.style.display=discount&&!fixedOffer?'':'none';badge.hidden=!discount||fixedOffer;
      badge.querySelector('.promo-sticker__label').textContent=discount?'-'+discount+'%':'';
      badge.setAttribute('aria-label',discount?strings.discount.replace('__PERCENT__',String(discount)):'');media.appendChild(badge);
      if(item.handle==='blusa-dama-v'){
        var fixedBadge=section.querySelector('[data-recent-fixed-badge]').content.firstElementChild.cloneNode(true);
        fixedBadge.hidden=!fixedOffer;fixedBadge.style.display=fixedOffer?'':'none';media.appendChild(fixedBadge);
      }
      var arrow=make('span','card__explore');arrow.setAttribute('aria-hidden','true');arrow.innerHTML='<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';media.appendChild(arrow);
      var info=make('div','info');
      if(item.vendor||item.type)info.appendChild(make('span','pcat',[item.type,item.vendor].filter(Boolean).join(' · ')));
      var row=make('div','row');var title=make('a','pname',item.title);title.href=productURL.href;title.setAttribute('data-card-title','');row.appendChild(title);
      var price=make('span','price'+(discount?' price--sale':'') ,quote?strings.quote:currency.format(variant.price/100));
      if(discount)price.appendChild(make('span','was',currency.format(variant.compare_at_price/100)));
      row.appendChild(price);info.appendChild(row);
      if(colorIndex>=0){
        var colors=[];item.variants.forEach(function(value){var color=colorOf(value);if(color&&!colors.includes(color))colors.push(color)});
        if(colors.length>1){
          var dots=make('div','variant-dots');dots.setAttribute('role','group');dots.setAttribute('aria-label','Variantes de color');
          colors.slice(0,4).forEach(function(color,index){
            var choice=item.variants.find(function(value){return colorOf(value)===color&&value.available})||item.variants.find(function(value){return colorOf(value)===color});
            if(color===colorOf(variant))choice=variant;
            var dot=make('button','vdot');dot.type='button';dot.setAttribute('aria-label',color);dot.setAttribute('aria-pressed',String(color===colorOf(variant)));
            var slug=color.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
            dot.style.backgroundColor='var(--swatch-'+slug+',#c9c5be)';
            if(/^(blanco|white|hueso|crema|ivory|marfil)$/i.test(color))dot.classList.add('vdot--light');
            dot.dataset.label=color;dot.dataset.price=currency.format(choice.price/100);dot.dataset.available=String(choice.available);
            dot.dataset.fixed=String(isTorinoFixed(item,choice));
            var choiceURL=new URL(productURL.href);choiceURL.searchParams.set('variant',String(choice.id));dot.dataset.variantUrl=choiceURL.href;
            var choiceImage=imageOf(choice)||imageOf(item.variants.find(function(value){return colorOf(value)===color&&imageOf(value)}));
            if(choiceImage)dot.dataset.img=safeImage(choiceImage);
            if(!quote&&choice.compare_at_price>choice.price){dot.dataset.compare=currency.format(choice.compare_at_price/100);dot.dataset.discount=String(Math.round((1-choice.price/choice.compare_at_price)*100))}
            dots.appendChild(dot);
          });
          if(colors.length>4){var more=make('span','vdot-more','+'+(colors.length-4)+' más');more.setAttribute('aria-label',(colors.length-4)+' colores más');dots.appendChild(more)}
          info.appendChild(dots);
        }
      }
      if(!info.querySelector('.variant-dots')){var emptyDots=make('div','variant-dots variant-dots--empty');emptyDots.setAttribute('aria-hidden','true');info.appendChild(emptyDots)}
      if(!quote){var availability=make('span','card__availability',strings.sold_out);availability.hidden=Boolean(variant.available);info.appendChild(availability)}
      article.appendChild(media);article.appendChild(info);return article;
    }
    Promise.allSettled(records.slice(0,4).map(function(record){
      var url=new URL(root+'products/'+encodeURIComponent(record.handle)+'.js',location.origin);
      return fetch(url.href,{credentials:'same-origin'}).then(function(response){if(!response.ok)throw new Error('Unavailable');return response.json()}).then(function(item){return card(item,record)});
    })).then(function(results){results.forEach(function(result){if(result.status==='fulfilled'&&result.value)grid.appendChild(result.value)});section.hidden=!grid.children.length});
  }
  document.querySelectorAll('[data-recent-products]').forEach(initRecentProducts);
  document.addEventListener('shopify:section:load',function(event){event.target.querySelectorAll('[data-recent-products]').forEach(initRecentProducts)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-related-products"] && !Shopify.designMode) return;
  try {
    
  function initRelatedProducts(section){
    if(!section||section.dataset.initialized)return;
    section.dataset.initialized='true';
    var url=new URL(section.dataset.url,location.origin);
    var current=new URL(location.href);
    ['preview_theme_id','preview_key'].forEach(function(name){if(current.searchParams.has(name))url.searchParams.set(name,current.searchParams.get(name))});
    fetch(url.href,{credentials:'same-origin'}).then(function(response){if(!response.ok)throw new Error('Unavailable');return response.text()}).then(function(text){
      var html=new DOMParser().parseFromString(text,'text/html');
      var result=html.getElementById(section.id);
      if(result&&result.querySelector('.card'))section.replaceChildren.apply(section,Array.from(result.childNodes));
    }).catch(function(){});
  }
  document.querySelectorAll('[data-related-products]').forEach(initRelatedProducts);
  document.addEventListener('shopify:section:load',function(event){event.target.querySelectorAll('[data-related-products]').forEach(initRelatedProducts)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-email"]) return;
  try {
    
  (() => {
    const popup = document.querySelector('[data-ks-popup]');
    if (!popup || popup.hasAttribute('data-ready')) return;
    popup.setAttribute('data-ready', '');

    const storageKey = 'ks_popup_v2';
    const closeButton = popup.querySelector('[data-ks-popup-close]');
    const emailInput = popup.querySelector('input[type="email"]');
    const formState = popup.getAttribute('data-form-state');
    const delay = Number(popup.getAttribute('data-delay')) || 12000;
    const scrollThreshold = Number(popup.getAttribute('data-scroll-threshold')) || 35;
    const cooldownDays = Number(popup.getAttribute('data-cooldown')) || 14;
    let previousFocus = null;
    let timer = null;

    const wasDismissed = () => {
      try {
        const dismissedAt = Number(localStorage.getItem(storageKey));
        return dismissedAt > 0 && Date.now() - dismissedAt < cooldownDays * 86400000;
      } catch (error) {
        return false;
      }
    };

    const rememberDismissal = () => {
      try {
        localStorage.setItem(storageKey, String(Date.now()));
      } catch (error) {
        return;
      }
    };

    const focusableElements = () => Array.from(
      popup.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])')
    );

    const openPopup = () => {
      if (!popup.hidden) return;
      previousFocus = document.activeElement;
      popup.hidden = false;
      document.documentElement.classList.add('ks-popup-lock');
      requestAnimationFrame(() => {
        popup.classList.add('is-open');
        (emailInput || closeButton).focus();
      });
      window.removeEventListener('scroll', handleScroll);
      if (timer) window.clearTimeout(timer);
    };

    const closePopup = () => {
      popup.classList.remove('is-open');
      document.documentElement.classList.remove('ks-popup-lock');
      rememberDismissal();
      window.setTimeout(() => {
        popup.hidden = true;
        if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
      }, 220);
    };

    const handleScroll = () => {
      const available = document.documentElement.scrollHeight - window.innerHeight;
      if (available <= 0) return;
      if ((window.scrollY / available) * 100 >= scrollThreshold) openPopup();
    };

    closeButton.addEventListener('click', closePopup);
    popup.addEventListener('click', (event) => {
      if (event.target === popup) closePopup();
    });

    popup.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closePopup();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = focusableElements();
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    if (formState === 'success' || formState === 'error') {
      openPopup();
      return;
    }

    if (wasDismissed()) return;
    timer = window.setTimeout(openPopup, delay);
    window.addEventListener('scroll', handleScroll, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
